import { SequenceHelper } from "@swivl-mono/helpers";
import { AllAPIScopePermissions, FMSType, LocationVarKey, SequenceEnabledStatus, SequenceInterface, SequenceSubType } from "@swivl-mono/types";
import { OptionsHelper } from "@swivl-mono/ui";
import { useEffect, useMemo } from "react";

import { IF_ALL, IF_ANY, IS_EQUAL, IS_NOT_EQUAL } from "../../../../Components/Worksheets/Types/Worksheet.Interface";
import {
  DropdownRow,
  InputRow,
  PageHeader,
  Section,
  SectionHeader,
  SwitchRow,
  TextAreaRow,
  TextRow
} from "../../../../Components/Worksheets/WorksheetComponent/WorksheetComponents";
import { usePropertiesGetLocationIds } from "../../../../Hooks/usePropertiesGetLocationIds";
import SequencesModel from "../../../../Models/Sequences/SequencesModel";
import { InactiveStatusSwitchRow } from "./Cortex.SequencesPastDue.InactiveStatusSwitchRow";

export const PAGE_KEYS: LocationVarKey[] = [
  LocationVarKey.WantsCronReceiptsPastDuePayments,
  LocationVarKey.HasFMSPlusPastDueNotes,
  LocationVarKey.FMSplusPastDueShortlinksEnabled,
  LocationVarKey.HasPastDueSpotPaymentPages,
  LocationVarKey.SequencePastDueProcessInactiveStatuses,
  LocationVarKey.LLMAgentInstructionsMakeAPayment,
  LocationVarKey.LLMAgentInstructionsAutopay,
  LocationVarKey.SequencePastDueDay00Enabled,
  LocationVarKey.SequencePastDueDay00Time,
  LocationVarKey.FMSplus0PastDueVoiceEnabled,
  LocationVarKey.FMSplus0PastDueSMSEnabled,
  LocationVarKey.FMSplus0PastDueSMSShortlink,
  LocationVarKey.FMSplus0PastDueEmailEnabled,
  LocationVarKey.FMSplus0PastDueEmailShortlink,
  LocationVarKey.FMSplus0PastDueVoiceMessage,
  LocationVarKey.FMSplus0PastDue1,
  LocationVarKey.FMSplus0PastDue2,
  LocationVarKey.FMSplus0PastDue2Shortlink,
  LocationVarKey.FMSplus0PastDue3,
  LocationVarKey.SequencePastDueDay01Enabled,
  LocationVarKey.SequencePastDueDay01Time,
  LocationVarKey.FMSplusp1PastDueVoiceEnabled,
  LocationVarKey.FMSplusp1PastDueSMSEnabled,
  LocationVarKey.FMSplusp1PastDueSMSShortlink,
  LocationVarKey.FMSplusp1PastDueEmailEnabled,
  LocationVarKey.FMSplusp1PastDueEmailShortlink,
  LocationVarKey.FMSplusp1PastDueVoiceMessage,
  LocationVarKey.FMSplusp1PastDue1,
  LocationVarKey.FMSplusp1PastDue2,
  LocationVarKey.FMSplusp1PastDue2Shortlink,
  LocationVarKey.FMSplusp1PastDue3,
  LocationVarKey.SequencePastDueDay02Enabled,
  LocationVarKey.SequencePastDueDay02Time,
  LocationVarKey.FMSplusp2PastDueVoiceEnabled,
  LocationVarKey.FMSplusp2PastDueSMSEnabled,
  LocationVarKey.FMSplusp2PastDueSMSShortlink,
  LocationVarKey.FMSplusp2PastDueEmailEnabled,
  LocationVarKey.FMSplusp2PastDueEmailShortlink,
  LocationVarKey.FMSplusp2PastDueVoiceMessage,
  LocationVarKey.FMSplusp2PastDue1,
  LocationVarKey.FMSplusp2PastDue2,
  LocationVarKey.FMSplusp2PastDue2Shortlink,
  LocationVarKey.FMSplusp2PastDue3,
  LocationVarKey.SequencePastDueDay03Enabled,
  LocationVarKey.SequencePastDueDay03Time,
  LocationVarKey.FMSplusp3PastDueVoiceEnabled,
  LocationVarKey.FMSplusp3PastDueSMSEnabled,
  LocationVarKey.FMSplusp3PastDueSMSShortlink,
  LocationVarKey.FMSplusp3PastDueEmailEnabled,
  LocationVarKey.FMSplusp3PastDueEmailShortlink,
  LocationVarKey.FMSplusp3PastDueVoiceMessage,
  LocationVarKey.FMSplusp3PastDue1,
  LocationVarKey.FMSplusp3PastDue2,
  LocationVarKey.FMSplusp3PastDue2Shortlink,
  LocationVarKey.FMSplusp3PastDue3,
  LocationVarKey.SequencePastDueDay05Enabled,
  LocationVarKey.SequencePastDueDay05Time,
  LocationVarKey.FMSplusp5PastDueVoiceEnabled,
  LocationVarKey.FMSplusp5PastDueSMSEnabled,
  LocationVarKey.FMSplusp5PastDueSMSShortlink,
  LocationVarKey.FMSplusp5PastDueEmailEnabled,
  LocationVarKey.FMSplusp5PastDueEmailShortlink,
  LocationVarKey.FMSplusp5PastDueVoiceMessage,
  LocationVarKey.FMSplusp5PastDue1,
  LocationVarKey.FMSplusp5PastDue2,
  LocationVarKey.FMSplusp5PastDue2Shortlink,
  LocationVarKey.FMSplusp5PastDue3,
  LocationVarKey.SequencePastDueDay07Enabled,
  LocationVarKey.SequencePastDueDay07Time,
  LocationVarKey.FMSplusp7PastDueVoiceEnabled,
  LocationVarKey.FMSplusp7PastDueSMSEnabled,
  LocationVarKey.FMSplusp7PastDueSMSShortlink,
  LocationVarKey.FMSplusp7PastDueEmailEnabled,
  LocationVarKey.FMSplusp7PastDueEmailShortlink,
  LocationVarKey.FMSplusp7PastDueVoiceMessage,
  LocationVarKey.FMSplusp7PastDue1,
  LocationVarKey.FMSplusp7PastDue2,
  LocationVarKey.FMSplusp7PastDue2Shortlink,
  LocationVarKey.FMSplusp7PastDue3,
  LocationVarKey.SequencePastDueDay10Enabled,
  LocationVarKey.SequencePastDueDay10Time,
  LocationVarKey.FMSplusp10PastDueVoiceEnabled,
  LocationVarKey.FMSplusp10PastDueSMSEnabled,
  LocationVarKey.FMSplusp10PastDueSMSShortlink,
  LocationVarKey.FMSplusp10PastDueEmailEnabled,
  LocationVarKey.FMSplusp10PastDueEmailShortlink,
  LocationVarKey.FMSplusp10PastDueVoiceMessage,
  LocationVarKey.FMSplusp10PastDue1,
  LocationVarKey.FMSplusp10PastDue2,
  LocationVarKey.FMSplusp10PastDue2Shortlink,
  LocationVarKey.FMSplusp10PastDue3,
  LocationVarKey.SequencePastDueDay14Enabled,
  LocationVarKey.SequencePastDueDay14Time,
  LocationVarKey.FMSplusp14PastDueVoiceEnabled,
  LocationVarKey.FMSplusp14PastDueSMSEnabled,
  LocationVarKey.FMSplusp14PastDueSMSShortlink,
  LocationVarKey.FMSplusp14PastDueEmailEnabled,
  LocationVarKey.FMSplusp14PastDueEmailShortlink,
  LocationVarKey.FMSplusp14PastDueVoiceMessage,
  LocationVarKey.FMSplusp14PastDue1,
  LocationVarKey.FMSplusp14PastDue2,
  LocationVarKey.FMSplusp14PastDue2Shortlink,
  LocationVarKey.FMSplusp14PastDue3,
  LocationVarKey.SequencePastDueDay30Enabled,
  LocationVarKey.SequencePastDueDay30Time,
  LocationVarKey.FMSplusp30PastDueVoiceEnabled,
  LocationVarKey.FMSplusp30PastDueSMSEnabled,
  LocationVarKey.FMSplusp30PastDueSMSShortlink,
  LocationVarKey.FMSplusp30PastDueEmailEnabled,
  LocationVarKey.FMSplusp30PastDueEmailShortlink,
  LocationVarKey.FMSplusp30PastDueVoiceMessage,
  LocationVarKey.FMSplusp30PastDue1,
  LocationVarKey.FMSplusp30PastDue2,
  LocationVarKey.FMSplusp30PastDue2Shortlink,
  LocationVarKey.FMSplusp30PastDue3,
  LocationVarKey.SequencePastDueDay45Enabled,
  LocationVarKey.SequencePastDueDay45Time,
  LocationVarKey.FMSplusp45PastDueVoiceEnabled,
  LocationVarKey.FMSplusp45PastDueSMSEnabled,
  LocationVarKey.FMSplusp45PastDueSMSShortlink,
  LocationVarKey.FMSplusp45PastDueEmailEnabled,
  LocationVarKey.FMSplusp45PastDueEmailShortlink,
  LocationVarKey.FMSplusp45PastDueVoiceMessage,
  LocationVarKey.FMSplusp45PastDue1,
  LocationVarKey.FMSplusp45PastDue2,
  LocationVarKey.FMSplusp45PastDue2Shortlink,
  LocationVarKey.FMSplusp45PastDue3,
  LocationVarKey.SequencePastDueRecurringEnabled,
  LocationVarKey.SequencePastDueRecurringTime,
  LocationVarKey.FMSplusRecurringPastDueVoiceEnabled,
  LocationVarKey.FMSplusRecurringPastDueSMSEnabled,
  LocationVarKey.FMSplusRecurringPastDueSMSShortlink,
  LocationVarKey.FMSplusRecurringPastDueEmailEnabled,
  LocationVarKey.FMSplusRecurringPastDueEmailShortlink,
  LocationVarKey.FMSplusRecurringPastDueVoiceMessage,
  LocationVarKey.FMSplusRecurringPastDue1,
  LocationVarKey.FMSplusRecurringPastDue2,
  LocationVarKey.FMSplusRecurringPastDue2Shortlink
];

export default function WorksheetView() {
  const { sequences } = SequencesModel.useState();
  const page = usePropertiesGetLocationIds();
  useEffect(() => {
    SequencesModel.load(false);
  }, []);
  const sequenceArray: SequenceInterface[] | undefined = useMemo(() => {
    if (sequences) {
      return Object.values(sequences);
    }
    return undefined;
  }, [sequences]);

  return (
    <>
      <PageHeader
        {...page}
        subheading="These sync with your FMS daily and will trigger a workflow to communicate with your customers around past due payments."
      >
        Past Due Payment Sequences
      </PageHeader>
      <SwitchRow {...page} keyName={LocationVarKey.WantsCronReceiptsPastDuePayments} label="Send Email Receipts" />
      <SwitchRow
        {...page}
        hideIf={IF_ALL([
          IS_NOT_EQUAL(LocationVarKey.FMSType, FMSType.SiteLink),
          IS_NOT_EQUAL(LocationVarKey.FMSType, FMSType.StorEdge),
          IS_NOT_EQUAL(LocationVarKey.FMSType, FMSType.SSMCloud),
          IS_NOT_EQUAL(LocationVarKey.FMSType, FMSType.QuikStor),
          IS_NOT_EQUAL(LocationVarKey.FMSType, FMSType.Monument),
          IS_NOT_EQUAL(LocationVarKey.FMSType, FMSType.Yardi)
        ])}
        keyName={LocationVarKey.HasFMSPlusPastDueNotes}
        label="Add FMS Notes"
      />
      <SwitchRow {...page} keyName={LocationVarKey.FMSplusPastDueShortlinksEnabled} label="Use Shortlinks" />
      <Section {...page} hideIf={IS_NOT_EQUAL(LocationVarKey.FMSType, FMSType.SSMCloud)}>
        <InactiveStatusSwitchRow
          {...page}
          status="Auction"
          label="Follow up with tenants in Auction status"
          tooltip="When enabled, swivl will send past due reminders to tenants in Auction status in SSM."
        />
        <InactiveStatusSwitchRow
          {...page}
          status="Overlock"
          label="Follow up with tenants in Overlock status"
          tooltip="When enabled, swivl will send past due reminders to tenants in Overlock status in SSM."
        />
      </Section>
      <Section
        {...page}
        hideIf={IF_ALL([
          IS_NOT_EQUAL(LocationVarKey.FMSType, FMSType.SiteLink),
          IS_NOT_EQUAL(LocationVarKey.FMSType, FMSType.StorEdge),
          IS_NOT_EQUAL(LocationVarKey.FMSType, FMSType.SSMCloud)
        ])}
      >
        <SwitchRow {...page} keyName={LocationVarKey.HasPastDueSpotPaymentPages} label="Use spot Payment Pages" />
        <TextRow {...page}>
          More information on spot Payment Pages can be found{" "}
          <a
            href="https://learn.tryswivl.com/migration/spot-payments"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "#FF5B02", textDecoration: "underline" }}
          >
            here
          </a>
          .
        </TextRow>
      </Section>

      <SectionHeader
        {...page}
        hideIf={IS_NOT_EQUAL(LocationVarKey.swivlHasVoice, "1")}
        subheading="For Voice interactions, if the tenant chooses to pay online or enroll in autopay, the collections agent will stay on the line to guide them through these steps."
      >
        {" "}
        Payment & Autopay Steps{" "}
      </SectionHeader>
      <TextAreaRow
        {...page}
        hideIf={IS_NOT_EQUAL(LocationVarKey.swivlHasVoice, "1")}
        keyName={LocationVarKey.LLMAgentInstructionsMakeAPayment}
        label="How to Make a Payment"
      />
      <TextAreaRow
        {...page}
        hideIf={IS_NOT_EQUAL(LocationVarKey.swivlHasVoice, "1")}
        keyName={LocationVarKey.LLMAgentInstructionsAutopay}
        label="How to Enroll in Autopay"
      />

      {sequenceArray && SequenceHelper.isAnySequenceSubType(SequenceSubType.PAST_DUE_DAY_00, sequenceArray) && (
        <>
          <SectionHeader {...page}>Day that payment is due</SectionHeader>
          <DropdownRow
            {...page}
            label="Enabled"
            marginTop
            keyName={LocationVarKey.SequencePastDueDay00Enabled}
            options={[
              { label: "Enabled", value: SequenceEnabledStatus.ENABLED },
              { label: "Disabled", value: SequenceEnabledStatus.DISABLED },
              { label: "Simulated", value: SequenceEnabledStatus.SIMULATED }
            ]}
          />
          <Section {...page} hideIf={IS_EQUAL(LocationVarKey.SequencePastDueDay00Enabled, SequenceEnabledStatus.DISABLED)}>
            <DropdownRow
              {...page}
              label="Time"
              marginTop
              keyName={LocationVarKey.SequencePastDueDay00Time}
              options={OptionsHelper.hoursOptionsLocalized()}
            />
            <h6>
              <b>Channel</b>
            </h6>
            <br></br>
            <SwitchRow
              {...page}
              hideIf={IS_NOT_EQUAL(LocationVarKey.swivlHasVoice, "1")}
              keyName={LocationVarKey.FMSplus0PastDueVoiceEnabled}
              label="Voice"
            />
            <SwitchRow {...page} keyName={LocationVarKey.FMSplus0PastDueSMSEnabled} label="SMS" />
            <InputRow
              {...page}
              hideIf={IF_ANY([
                IS_NOT_EQUAL(LocationVarKey.FMSplus0PastDueSMSEnabled, "1"),
                IS_NOT_EQUAL(LocationVarKey.FMSplusPastDueShortlinksEnabled, "1")
              ])}
              keyName={LocationVarKey.FMSplus0PastDueSMSShortlink}
              label="SMS Link to Shorten"
            />
            <SwitchRow {...page} keyName={LocationVarKey.FMSplus0PastDueEmailEnabled} label="Email" />
            <InputRow
              {...page}
              hideIf={IF_ANY([
                IS_NOT_EQUAL(LocationVarKey.FMSplus0PastDueEmailEnabled, "1"),
                IS_NOT_EQUAL(LocationVarKey.FMSplusPastDueShortlinksEnabled, "1")
              ])}
              keyName={LocationVarKey.FMSplus0PastDueEmailShortlink}
              label="Email Link to Shorten"
            />

            <TextAreaRow
              {...page}
              hideIf={IF_ANY([IS_NOT_EQUAL(LocationVarKey.FMSplus0PastDueVoiceEnabled, "1"), IS_NOT_EQUAL(LocationVarKey.swivlHasVoice, "1")])}
              marginTop
              label=" Voice Message"
              keyName={LocationVarKey.FMSplus0PastDueVoiceMessage}
            />

            <Section {...page} hideIf={IS_NOT_EQUAL(LocationVarKey.FMSplus0PastDueSMSEnabled, "1")}>
              <TextAreaRow {...page} marginTop label=" SMS Message 1" keyName={LocationVarKey.FMSplus0PastDue1} />
              <TextAreaRow
                {...page}
                hideIf={IF_ANY([
                  IS_EQUAL(LocationVarKey.FMSplusPastDueShortlinksEnabled, "1"),
                  IS_EQUAL(LocationVarKey.HasPastDueSpotPaymentPages, "1")
                ])}
                marginTop
                label=" SMS Message 2 (Optional)"
                keyName={LocationVarKey.FMSplus0PastDue2}
                enableSwitchVar={LocationVarKey.FMSplus0PastDue2Enabled}
              />
              <TextAreaRow
                {...page}
                hideIf={IF_ALL([
                  IS_NOT_EQUAL(LocationVarKey.FMSplusPastDueShortlinksEnabled, "1"),
                  IS_NOT_EQUAL(LocationVarKey.HasPastDueSpotPaymentPages, "1")
                ])}
                marginTop
                label=" SMS Message 2 (Optional)"
                keyName={LocationVarKey.FMSplus0PastDue2Shortlink}
                enableSwitchVar={LocationVarKey.FMSplus0PastDue2Enabled}
              />
              <TextAreaRow
                {...page}
                marginTop
                label=" SMS Message 3 (Optional)"
                keyName={LocationVarKey.FMSplus0PastDue3}
                enableSwitchVar={LocationVarKey.FMSplus0PastDue3Enabled}
              />
            </Section>
          </Section>
        </>
      )}

      {sequenceArray && SequenceHelper.isAnySequenceSubType(SequenceSubType.PAST_DUE_DAY_01, sequenceArray) && (
        <>
          <SectionHeader {...page}>1 day after past due</SectionHeader>
          <DropdownRow
            {...page}
            label="Enabled"
            marginTop
            keyName={LocationVarKey.SequencePastDueDay01Enabled}
            options={[
              { label: "Enabled", value: SequenceEnabledStatus.ENABLED },
              { label: "Disabled", value: SequenceEnabledStatus.DISABLED },
              { label: "Simulated", value: SequenceEnabledStatus.SIMULATED }
            ]}
          />
          <Section {...page} hideIf={IS_EQUAL(LocationVarKey.SequencePastDueDay01Enabled, SequenceEnabledStatus.DISABLED)}>
            <DropdownRow
              {...page}
              label="Time"
              marginTop
              keyName={LocationVarKey.SequencePastDueDay01Time}
              options={OptionsHelper.hoursOptionsLocalized()}
            />
            <h6>
              <b>Channel</b>
            </h6>
            <br></br>
            <SwitchRow
              {...page}
              hideIf={IS_NOT_EQUAL(LocationVarKey.swivlHasVoice, "1")}
              keyName={LocationVarKey.FMSplusp1PastDueVoiceEnabled}
              label="Voice"
            />
            <SwitchRow {...page} keyName={LocationVarKey.FMSplusp1PastDueSMSEnabled} label="SMS" />
            <InputRow
              {...page}
              hideIf={IF_ANY([
                IS_NOT_EQUAL(LocationVarKey.FMSplusp1PastDueSMSEnabled, "1"),
                IS_NOT_EQUAL(LocationVarKey.FMSplusPastDueShortlinksEnabled, "1")
              ])}
              keyName={LocationVarKey.FMSplusp1PastDueSMSShortlink}
              label="SMS Link to Shorten"
            />
            <SwitchRow {...page} keyName={LocationVarKey.FMSplusp1PastDueEmailEnabled} label="Email" />
            <InputRow
              {...page}
              hideIf={IF_ANY([
                IS_NOT_EQUAL(LocationVarKey.FMSplusp1PastDueEmailEnabled, "1"),
                IS_NOT_EQUAL(LocationVarKey.FMSplusPastDueShortlinksEnabled, "1")
              ])}
              keyName={LocationVarKey.FMSplusp1PastDueEmailShortlink}
              label="Email Link to Shorten"
            />

            <TextAreaRow
              {...page}
              hideIf={IF_ANY([IS_NOT_EQUAL(LocationVarKey.FMSplusp1PastDueVoiceEnabled, "1"), IS_NOT_EQUAL(LocationVarKey.swivlHasVoice, "1")])}
              marginTop
              label=" Voice Message"
              keyName={LocationVarKey.FMSplusp1PastDueVoiceMessage}
            />

            <Section {...page} hideIf={IS_NOT_EQUAL(LocationVarKey.FMSplusp1PastDueSMSEnabled, "1")}>
              <TextAreaRow {...page} marginTop label=" SMS Message 1" keyName={LocationVarKey.FMSplusp1PastDue1} />
              <TextAreaRow
                {...page}
                hideIf={IF_ANY([
                  IS_EQUAL(LocationVarKey.FMSplusPastDueShortlinksEnabled, "1"),
                  IS_EQUAL(LocationVarKey.HasPastDueSpotPaymentPages, "1")
                ])}
                marginTop
                label=" SMS Message 2 (Optional)"
                keyName={LocationVarKey.FMSplusp1PastDue2}
                enableSwitchVar={LocationVarKey.FMSplusp1PastDue2Enabled}
              />
              <TextAreaRow
                {...page}
                hideIf={IF_ALL([
                  IS_NOT_EQUAL(LocationVarKey.FMSplusPastDueShortlinksEnabled, "1"),
                  IS_NOT_EQUAL(LocationVarKey.HasPastDueSpotPaymentPages, "1")
                ])}
                marginTop
                label=" SMS Message 2 (Optional)"
                keyName={LocationVarKey.FMSplusp1PastDue2Shortlink}
                enableSwitchVar={LocationVarKey.FMSplusp1PastDue2Enabled}
              />
              <TextAreaRow
                {...page}
                marginTop
                label=" SMS Message 3 (Optional)"
                keyName={LocationVarKey.FMSplusp1PastDue3}
                enableSwitchVar={LocationVarKey.FMSplusp1PastDue3Enabled}
              />
            </Section>
          </Section>
        </>
      )}

      {sequenceArray && SequenceHelper.isAnySequenceSubType(SequenceSubType.PAST_DUE_DAY_02, sequenceArray) && (
        <>
          <SectionHeader {...page}>2 days after past due</SectionHeader>
          <DropdownRow
            {...page}
            label="Enabled"
            marginTop
            keyName={LocationVarKey.SequencePastDueDay02Enabled}
            options={[
              { label: "Enabled", value: SequenceEnabledStatus.ENABLED },
              { label: "Disabled", value: SequenceEnabledStatus.DISABLED },
              { label: "Simulated", value: SequenceEnabledStatus.SIMULATED }
            ]}
          />
          <Section {...page} hideIf={IS_EQUAL(LocationVarKey.SequencePastDueDay02Enabled, SequenceEnabledStatus.DISABLED)}>
            <DropdownRow
              {...page}
              label="Time"
              marginTop
              keyName={LocationVarKey.SequencePastDueDay02Time}
              options={OptionsHelper.hoursOptionsLocalized()}
            />
            <h6>
              <b>Channel</b>
            </h6>
            <br></br>
            <SwitchRow
              {...page}
              hideIf={IS_NOT_EQUAL(LocationVarKey.swivlHasVoice, "1")}
              keyName={LocationVarKey.FMSplusp2PastDueVoiceEnabled}
              label="Voice"
            />
            <SwitchRow {...page} keyName={LocationVarKey.FMSplusp2PastDueSMSEnabled} label="SMS" />
            <InputRow
              {...page}
              hideIf={IF_ANY([
                IS_NOT_EQUAL(LocationVarKey.FMSplusp2PastDueSMSEnabled, "1"),
                IS_NOT_EQUAL(LocationVarKey.FMSplusPastDueShortlinksEnabled, "1")
              ])}
              keyName={LocationVarKey.FMSplusp2PastDueSMSShortlink}
              label="SMS Link to Shorten"
            />
            <SwitchRow {...page} keyName={LocationVarKey.FMSplusp2PastDueEmailEnabled} label="Email" />
            <InputRow
              {...page}
              hideIf={IF_ANY([
                IS_NOT_EQUAL(LocationVarKey.FMSplusp2PastDueEmailEnabled, "1"),
                IS_NOT_EQUAL(LocationVarKey.FMSplusPastDueShortlinksEnabled, "1")
              ])}
              keyName={LocationVarKey.FMSplusp2PastDueEmailShortlink}
              label="Email Link to Shorten"
            />

            <TextAreaRow
              {...page}
              hideIf={IF_ANY([IS_NOT_EQUAL(LocationVarKey.FMSplusp2PastDueVoiceEnabled, "1"), IS_NOT_EQUAL(LocationVarKey.swivlHasVoice, "1")])}
              marginTop
              label=" Voice Message"
              keyName={LocationVarKey.FMSplusp2PastDueVoiceMessage}
            />

            <Section {...page} hideIf={IS_NOT_EQUAL(LocationVarKey.FMSplusp2PastDueSMSEnabled, "1")}>
              <TextAreaRow {...page} marginTop label=" SMS Message 1" keyName={LocationVarKey.FMSplusp2PastDue1} />
              <TextAreaRow
                {...page}
                hideIf={IF_ANY([
                  IS_EQUAL(LocationVarKey.FMSplusPastDueShortlinksEnabled, "1"),
                  IS_EQUAL(LocationVarKey.HasPastDueSpotPaymentPages, "1")
                ])}
                marginTop
                label=" SMS Message 2 (Optional)"
                keyName={LocationVarKey.FMSplusp2PastDue2}
                enableSwitchVar={LocationVarKey.FMSplusp2PastDue2Enabled}
              />
              <TextAreaRow
                {...page}
                hideIf={IF_ALL([
                  IS_NOT_EQUAL(LocationVarKey.FMSplusPastDueShortlinksEnabled, "1"),
                  IS_NOT_EQUAL(LocationVarKey.HasPastDueSpotPaymentPages, "1")
                ])}
                marginTop
                label=" SMS Message 2 (Optional)"
                keyName={LocationVarKey.FMSplusp2PastDue2Shortlink}
                enableSwitchVar={LocationVarKey.FMSplusp2PastDue2Enabled}
              />
              <TextAreaRow
                {...page}
                marginTop
                label=" SMS Message 3 (Optional)"
                keyName={LocationVarKey.FMSplusp2PastDue3}
                enableSwitchVar={LocationVarKey.FMSplusp2PastDue3Enabled}
              />
            </Section>
          </Section>
        </>
      )}

      {sequenceArray && SequenceHelper.isAnySequenceSubType(SequenceSubType.PAST_DUE_DAY_03, sequenceArray) && (
        <>
          <SectionHeader {...page}>3 days after past due</SectionHeader>
          <DropdownRow
            {...page}
            label="Enabled"
            marginTop
            keyName={LocationVarKey.SequencePastDueDay03Enabled}
            options={[
              { label: "Enabled", value: SequenceEnabledStatus.ENABLED },
              { label: "Disabled", value: SequenceEnabledStatus.DISABLED },
              { label: "Simulated", value: SequenceEnabledStatus.SIMULATED }
            ]}
          />
          <Section {...page} hideIf={IS_EQUAL(LocationVarKey.SequencePastDueDay03Enabled, SequenceEnabledStatus.DISABLED)}>
            <DropdownRow
              {...page}
              label="Time"
              marginTop
              keyName={LocationVarKey.SequencePastDueDay03Time}
              options={OptionsHelper.hoursOptionsLocalized()}
            />
            <h6>
              <b>Channel</b>
            </h6>
            <br></br>
            <SwitchRow
              {...page}
              hideIf={IS_NOT_EQUAL(LocationVarKey.swivlHasVoice, "1")}
              keyName={LocationVarKey.FMSplusp3PastDueVoiceEnabled}
              label="Voice"
            />
            <SwitchRow {...page} keyName={LocationVarKey.FMSplusp3PastDueSMSEnabled} label="SMS" />
            <InputRow
              {...page}
              hideIf={IF_ANY([
                IS_NOT_EQUAL(LocationVarKey.FMSplusp3PastDueSMSEnabled, "1"),
                IS_NOT_EQUAL(LocationVarKey.FMSplusPastDueShortlinksEnabled, "1")
              ])}
              keyName={LocationVarKey.FMSplusp3PastDueSMSShortlink}
              label="SMS Link to Shorten"
            />
            <SwitchRow {...page} keyName={LocationVarKey.FMSplusp3PastDueEmailEnabled} label="Email" />
            <InputRow
              {...page}
              hideIf={IF_ANY([
                IS_NOT_EQUAL(LocationVarKey.FMSplusp3PastDueEmailEnabled, "1"),
                IS_NOT_EQUAL(LocationVarKey.FMSplusPastDueShortlinksEnabled, "1")
              ])}
              keyName={LocationVarKey.FMSplusp3PastDueEmailShortlink}
              label="Email Link to Shorten"
            />

            <TextAreaRow
              {...page}
              hideIf={IF_ANY([IS_NOT_EQUAL(LocationVarKey.FMSplusp3PastDueVoiceEnabled, "1"), IS_NOT_EQUAL(LocationVarKey.swivlHasVoice, "1")])}
              marginTop
              label=" Voice Message"
              keyName={LocationVarKey.FMSplusp3PastDueVoiceMessage}
            />

            <Section {...page} hideIf={IS_NOT_EQUAL(LocationVarKey.FMSplusp3PastDueSMSEnabled, "1")}>
              <TextAreaRow {...page} marginTop label=" SMS Message 1" keyName={LocationVarKey.FMSplusp3PastDue1} />
              <TextAreaRow
                {...page}
                hideIf={IF_ANY([
                  IS_EQUAL(LocationVarKey.FMSplusPastDueShortlinksEnabled, "1"),
                  IS_EQUAL(LocationVarKey.HasPastDueSpotPaymentPages, "1")
                ])}
                marginTop
                label=" SMS Message 2 (Optional)"
                keyName={LocationVarKey.FMSplusp3PastDue2}
                enableSwitchVar={LocationVarKey.FMSplusp3PastDue2Enabled}
              />
              <TextAreaRow
                {...page}
                hideIf={IF_ALL([
                  IS_NOT_EQUAL(LocationVarKey.FMSplusPastDueShortlinksEnabled, "1"),
                  IS_NOT_EQUAL(LocationVarKey.HasPastDueSpotPaymentPages, "1")
                ])}
                marginTop
                label=" SMS Message 2 (Optional)"
                keyName={LocationVarKey.FMSplusp3PastDue2Shortlink}
                enableSwitchVar={LocationVarKey.FMSplusp3PastDue2Enabled}
              />
              <TextAreaRow
                {...page}
                marginTop
                label=" SMS Message 3 (Optional)"
                keyName={LocationVarKey.FMSplusp3PastDue3}
                enableSwitchVar={LocationVarKey.FMSplusp3PastDue3Enabled}
              />
            </Section>
          </Section>
        </>
      )}

      {sequenceArray && SequenceHelper.isAnySequenceSubType(SequenceSubType.PAST_DUE_DAY_05, sequenceArray) && (
        <>
          <SectionHeader {...page}>5 days after past due</SectionHeader>
          <DropdownRow
            {...page}
            label="Enabled"
            marginTop
            keyName={LocationVarKey.SequencePastDueDay05Enabled}
            options={[
              { label: "Enabled", value: SequenceEnabledStatus.ENABLED },
              { label: "Disabled", value: SequenceEnabledStatus.DISABLED },
              { label: "Simulated", value: SequenceEnabledStatus.SIMULATED }
            ]}
          />
          <Section {...page} hideIf={IS_EQUAL(LocationVarKey.SequencePastDueDay05Enabled, SequenceEnabledStatus.DISABLED)}>
            <DropdownRow
              {...page}
              label="Time"
              marginTop
              keyName={LocationVarKey.SequencePastDueDay05Time}
              options={OptionsHelper.hoursOptionsLocalized()}
            />
            <h6>
              <b>Channel</b>
            </h6>
            <br></br>
            <SwitchRow
              {...page}
              hideIf={IS_NOT_EQUAL(LocationVarKey.swivlHasVoice, "1")}
              keyName={LocationVarKey.FMSplusp5PastDueVoiceEnabled}
              label="Voice"
            />
            <SwitchRow {...page} keyName={LocationVarKey.FMSplusp5PastDueSMSEnabled} label="SMS" />
            <InputRow
              {...page}
              hideIf={IF_ANY([
                IS_NOT_EQUAL(LocationVarKey.FMSplusp5PastDueSMSEnabled, "1"),
                IS_NOT_EQUAL(LocationVarKey.FMSplusPastDueShortlinksEnabled, "1")
              ])}
              keyName={LocationVarKey.FMSplusp5PastDueSMSShortlink}
              label="SMS Link to Shorten"
            />
            <SwitchRow {...page} keyName={LocationVarKey.FMSplusp5PastDueEmailEnabled} label="Email" />
            <InputRow
              {...page}
              hideIf={IF_ANY([
                IS_NOT_EQUAL(LocationVarKey.FMSplusp5PastDueEmailEnabled, "1"),
                IS_NOT_EQUAL(LocationVarKey.FMSplusPastDueShortlinksEnabled, "1")
              ])}
              keyName={LocationVarKey.FMSplusp5PastDueEmailShortlink}
              label="Email Link to Shorten"
            />

            <TextAreaRow
              {...page}
              hideIf={IF_ANY([IS_NOT_EQUAL(LocationVarKey.FMSplusp5PastDueVoiceEnabled, "1"), IS_NOT_EQUAL(LocationVarKey.swivlHasVoice, "1")])}
              marginTop
              label=" Voice Message"
              keyName={LocationVarKey.FMSplusp5PastDueVoiceMessage}
            />

            <Section {...page} hideIf={IS_NOT_EQUAL(LocationVarKey.FMSplusp5PastDueSMSEnabled, "1")}>
              <TextAreaRow {...page} marginTop label=" SMS Message 1" keyName={LocationVarKey.FMSplusp5PastDue1} />
              <TextAreaRow
                {...page}
                hideIf={IF_ANY([
                  IS_EQUAL(LocationVarKey.FMSplusPastDueShortlinksEnabled, "1"),
                  IS_EQUAL(LocationVarKey.HasPastDueSpotPaymentPages, "1")
                ])}
                marginTop
                label=" SMS Message 2 (Optional)"
                keyName={LocationVarKey.FMSplusp5PastDue2}
                enableSwitchVar={LocationVarKey.FMSplusp5PastDue2Enabled}
              />
              <TextAreaRow
                {...page}
                hideIf={IF_ALL([
                  IS_NOT_EQUAL(LocationVarKey.FMSplusPastDueShortlinksEnabled, "1"),
                  IS_NOT_EQUAL(LocationVarKey.HasPastDueSpotPaymentPages, "1")
                ])}
                marginTop
                label=" SMS Message 2 (Optional)"
                keyName={LocationVarKey.FMSplusp5PastDue2Shortlink}
                enableSwitchVar={LocationVarKey.FMSplusp5PastDue2Enabled}
              />
              <TextAreaRow
                {...page}
                marginTop
                label=" SMS Message 3 (Optional)"
                keyName={LocationVarKey.FMSplusp5PastDue3}
                enableSwitchVar={LocationVarKey.FMSplusp5PastDue3Enabled}
              />
            </Section>
          </Section>
        </>
      )}

      {sequenceArray && SequenceHelper.isAnySequenceSubType(SequenceSubType.PAST_DUE_DAY_07, sequenceArray) && (
        <>
          <SectionHeader {...page}>7 days after past due</SectionHeader>
          <DropdownRow
            {...page}
            label="Enabled"
            marginTop
            keyName={LocationVarKey.SequencePastDueDay07Enabled}
            options={[
              { label: "Enabled", value: SequenceEnabledStatus.ENABLED },
              { label: "Disabled", value: SequenceEnabledStatus.DISABLED },
              { label: "Simulated", value: SequenceEnabledStatus.SIMULATED }
            ]}
          />
          <Section {...page} hideIf={IS_EQUAL(LocationVarKey.SequencePastDueDay07Enabled, SequenceEnabledStatus.DISABLED)}>
            <DropdownRow
              {...page}
              label="Time"
              marginTop
              keyName={LocationVarKey.SequencePastDueDay07Time}
              options={OptionsHelper.hoursOptionsLocalized()}
            />
            <h6>
              <b>Channel</b>
            </h6>
            <br></br>
            <SwitchRow
              {...page}
              hideIf={IS_NOT_EQUAL(LocationVarKey.swivlHasVoice, "1")}
              keyName={LocationVarKey.FMSplusp7PastDueVoiceEnabled}
              label="Voice"
            />
            <SwitchRow {...page} keyName={LocationVarKey.FMSplusp7PastDueSMSEnabled} label="SMS" />
            <InputRow
              {...page}
              hideIf={IF_ANY([
                IS_NOT_EQUAL(LocationVarKey.FMSplusp7PastDueSMSEnabled, "1"),
                IS_NOT_EQUAL(LocationVarKey.FMSplusPastDueShortlinksEnabled, "1")
              ])}
              keyName={LocationVarKey.FMSplusp7PastDueSMSShortlink}
              label="SMS Link to Shorten"
            />
            <SwitchRow {...page} keyName={LocationVarKey.FMSplusp7PastDueEmailEnabled} label="Email" />
            <InputRow
              {...page}
              hideIf={IF_ANY([
                IS_NOT_EQUAL(LocationVarKey.FMSplusp7PastDueEmailEnabled, "1"),
                IS_NOT_EQUAL(LocationVarKey.FMSplusPastDueShortlinksEnabled, "1")
              ])}
              keyName={LocationVarKey.FMSplusp7PastDueEmailShortlink}
              label="Email Link to Shorten"
            />

            <TextAreaRow
              {...page}
              hideIf={IF_ANY([IS_NOT_EQUAL(LocationVarKey.FMSplusp7PastDueVoiceEnabled, "1"), IS_NOT_EQUAL(LocationVarKey.swivlHasVoice, "1")])}
              marginTop
              label=" Voice Message"
              keyName={LocationVarKey.FMSplusp7PastDueVoiceMessage}
            />

            <Section {...page} hideIf={IS_NOT_EQUAL(LocationVarKey.FMSplusp7PastDueSMSEnabled, "1")}>
              <TextAreaRow {...page} marginTop label=" SMS Message 1" keyName={LocationVarKey.FMSplusp7PastDue1} />
              <TextAreaRow
                {...page}
                hideIf={IF_ANY([
                  IS_EQUAL(LocationVarKey.FMSplusPastDueShortlinksEnabled, "1"),
                  IS_EQUAL(LocationVarKey.HasPastDueSpotPaymentPages, "1")
                ])}
                marginTop
                label=" SMS Message 2 (Optional)"
                keyName={LocationVarKey.FMSplusp7PastDue2}
                enableSwitchVar={LocationVarKey.FMSplusp7PastDue2Enabled}
              />
              <TextAreaRow
                {...page}
                hideIf={IF_ALL([
                  IS_NOT_EQUAL(LocationVarKey.FMSplusPastDueShortlinksEnabled, "1"),
                  IS_NOT_EQUAL(LocationVarKey.HasPastDueSpotPaymentPages, "1")
                ])}
                marginTop
                label=" SMS Message 2 (Optional)"
                keyName={LocationVarKey.FMSplusp7PastDue2Shortlink}
                enableSwitchVar={LocationVarKey.FMSplusp7PastDue2Enabled}
              />
              <TextAreaRow
                {...page}
                marginTop
                label=" SMS Message 3 (Optional)"
                keyName={LocationVarKey.FMSplusp7PastDue3}
                enableSwitchVar={LocationVarKey.FMSplusp7PastDue3Enabled}
              />
            </Section>
          </Section>
        </>
      )}

      {sequenceArray && SequenceHelper.isAnySequenceSubType(SequenceSubType.PAST_DUE_DAY_10, sequenceArray) && (
        <>
          <SectionHeader {...page}>10 days after past due</SectionHeader>
          <DropdownRow
            {...page}
            label="Enabled"
            marginTop
            keyName={LocationVarKey.SequencePastDueDay10Enabled}
            options={[
              { label: "Enabled", value: SequenceEnabledStatus.ENABLED },
              { label: "Disabled", value: SequenceEnabledStatus.DISABLED },
              { label: "Simulated", value: SequenceEnabledStatus.SIMULATED }
            ]}
          />
          <Section {...page} hideIf={IS_EQUAL(LocationVarKey.SequencePastDueDay10Enabled, SequenceEnabledStatus.DISABLED)}>
            <DropdownRow
              {...page}
              label="Time"
              marginTop
              keyName={LocationVarKey.SequencePastDueDay10Time}
              options={OptionsHelper.hoursOptionsLocalized()}
            />
            <h6>
              <b>Channel</b>
            </h6>
            <br></br>
            <SwitchRow
              {...page}
              hideIf={IS_NOT_EQUAL(LocationVarKey.swivlHasVoice, "1")}
              keyName={LocationVarKey.FMSplusp10PastDueVoiceEnabled}
              label="Voice"
            />
            <SwitchRow {...page} keyName={LocationVarKey.FMSplusp10PastDueSMSEnabled} label="SMS" />
            <InputRow
              {...page}
              hideIf={IF_ANY([
                IS_NOT_EQUAL(LocationVarKey.FMSplusp10PastDueSMSEnabled, "1"),
                IS_NOT_EQUAL(LocationVarKey.FMSplusPastDueShortlinksEnabled, "1")
              ])}
              keyName={LocationVarKey.FMSplusp10PastDueSMSShortlink}
              label="SMS Link to Shorten"
            />
            <SwitchRow {...page} keyName={LocationVarKey.FMSplusp10PastDueEmailEnabled} label="Email" />
            <InputRow
              {...page}
              hideIf={IF_ANY([
                IS_NOT_EQUAL(LocationVarKey.FMSplusp10PastDueEmailEnabled, "1"),
                IS_NOT_EQUAL(LocationVarKey.FMSplusPastDueShortlinksEnabled, "1")
              ])}
              keyName={LocationVarKey.FMSplusp10PastDueEmailShortlink}
              label="Email Link to Shorten"
            />

            <TextAreaRow
              {...page}
              hideIf={IF_ANY([IS_NOT_EQUAL(LocationVarKey.FMSplusp10PastDueVoiceEnabled, "1"), IS_NOT_EQUAL(LocationVarKey.swivlHasVoice, "1")])}
              marginTop
              label=" Voice Message"
              keyName={LocationVarKey.FMSplusp10PastDueVoiceMessage}
            />

            <Section {...page} hideIf={IS_NOT_EQUAL(LocationVarKey.FMSplusp10PastDueSMSEnabled, "1")}>
              <TextAreaRow {...page} marginTop label=" SMS Message 1" keyName={LocationVarKey.FMSplusp10PastDue1} />
              <TextAreaRow
                {...page}
                hideIf={IF_ANY([
                  IS_EQUAL(LocationVarKey.FMSplusPastDueShortlinksEnabled, "1"),
                  IS_EQUAL(LocationVarKey.HasPastDueSpotPaymentPages, "1")
                ])}
                marginTop
                label=" SMS Message 2 (Optional)"
                keyName={LocationVarKey.FMSplusp10PastDue2}
                enableSwitchVar={LocationVarKey.FMSplusp10PastDue2Enabled}
              />
              <TextAreaRow
                {...page}
                hideIf={IF_ALL([
                  IS_NOT_EQUAL(LocationVarKey.FMSplusPastDueShortlinksEnabled, "1"),
                  IS_NOT_EQUAL(LocationVarKey.HasPastDueSpotPaymentPages, "1")
                ])}
                marginTop
                label=" SMS Message 2 (Optional)"
                keyName={LocationVarKey.FMSplusp10PastDue2Shortlink}
                enableSwitchVar={LocationVarKey.FMSplusp10PastDue2Enabled}
              />
              <TextAreaRow
                {...page}
                marginTop
                label=" SMS Message 3 (Optional)"
                keyName={LocationVarKey.FMSplusp10PastDue3}
                enableSwitchVar={LocationVarKey.FMSplusp10PastDue3Enabled}
              />
            </Section>
          </Section>
        </>
      )}

      {sequenceArray && SequenceHelper.isAnySequenceSubType(SequenceSubType.PAST_DUE_DAY_14, sequenceArray) && (
        <>
          <SectionHeader {...page}>14 days after past due</SectionHeader>
          <DropdownRow
            {...page}
            label="Enabled"
            marginTop
            keyName={LocationVarKey.SequencePastDueDay14Enabled}
            options={[
              { label: "Enabled", value: SequenceEnabledStatus.ENABLED },
              { label: "Disabled", value: SequenceEnabledStatus.DISABLED },
              { label: "Simulated", value: SequenceEnabledStatus.SIMULATED }
            ]}
          />
          <Section {...page} hideIf={IS_EQUAL(LocationVarKey.SequencePastDueDay14Enabled, SequenceEnabledStatus.DISABLED)}>
            <DropdownRow
              {...page}
              label="Time"
              marginTop
              keyName={LocationVarKey.SequencePastDueDay14Time}
              options={OptionsHelper.hoursOptionsLocalized()}
            />
            <h6>
              <b>Channel</b>
            </h6>
            <br></br>
            <SwitchRow
              {...page}
              hideIf={IS_NOT_EQUAL(LocationVarKey.swivlHasVoice, "1")}
              keyName={LocationVarKey.FMSplusp14PastDueVoiceEnabled}
              label="Voice"
            />
            <SwitchRow {...page} keyName={LocationVarKey.FMSplusp14PastDueSMSEnabled} label="SMS" />
            <InputRow
              {...page}
              hideIf={IF_ANY([
                IS_NOT_EQUAL(LocationVarKey.FMSplusp14PastDueSMSEnabled, "1"),
                IS_NOT_EQUAL(LocationVarKey.FMSplusPastDueShortlinksEnabled, "1")
              ])}
              keyName={LocationVarKey.FMSplusp14PastDueSMSShortlink}
              label="SMS Link to Shorten"
            />
            <SwitchRow {...page} keyName={LocationVarKey.FMSplusp14PastDueEmailEnabled} label="Email" />
            <InputRow
              {...page}
              hideIf={IF_ANY([
                IS_NOT_EQUAL(LocationVarKey.FMSplusp14PastDueEmailEnabled, "1"),
                IS_NOT_EQUAL(LocationVarKey.FMSplusPastDueShortlinksEnabled, "1")
              ])}
              keyName={LocationVarKey.FMSplusp14PastDueEmailShortlink}
              label="Email Link to Shorten"
            />

            <TextAreaRow
              {...page}
              hideIf={IF_ANY([IS_NOT_EQUAL(LocationVarKey.FMSplusp14PastDueVoiceEnabled, "1"), IS_NOT_EQUAL(LocationVarKey.swivlHasVoice, "1")])}
              marginTop
              label=" Voice Message"
              keyName={LocationVarKey.FMSplusp14PastDueVoiceMessage}
            />

            <Section {...page} hideIf={IS_NOT_EQUAL(LocationVarKey.FMSplusp14PastDueSMSEnabled, "1")}>
              <TextAreaRow {...page} marginTop label=" SMS Message 1" keyName={LocationVarKey.FMSplusp14PastDue1} />
              <TextAreaRow
                {...page}
                hideIf={IF_ANY([
                  IS_EQUAL(LocationVarKey.FMSplusPastDueShortlinksEnabled, "1"),
                  IS_EQUAL(LocationVarKey.HasPastDueSpotPaymentPages, "1")
                ])}
                marginTop
                label=" SMS Message 2 (Optional)"
                keyName={LocationVarKey.FMSplusp14PastDue2}
                enableSwitchVar={LocationVarKey.FMSplusp14PastDue2Enabled}
              />
              <TextAreaRow
                {...page}
                hideIf={IF_ALL([
                  IS_NOT_EQUAL(LocationVarKey.FMSplusPastDueShortlinksEnabled, "1"),
                  IS_NOT_EQUAL(LocationVarKey.HasPastDueSpotPaymentPages, "1")
                ])}
                marginTop
                label=" SMS Message 2 (Optional)"
                keyName={LocationVarKey.FMSplusp14PastDue2Shortlink}
                enableSwitchVar={LocationVarKey.FMSplusp14PastDue2Enabled}
              />
              <TextAreaRow
                {...page}
                marginTop
                label=" SMS Message 3 (Optional)"
                keyName={LocationVarKey.FMSplusp14PastDue3}
                enableSwitchVar={LocationVarKey.FMSplusp14PastDue3Enabled}
              />
            </Section>
          </Section>
        </>
      )}

      {sequenceArray && SequenceHelper.isAnySequenceSubType(SequenceSubType.PAST_DUE_DAY_30, sequenceArray) && (
        <>
          <SectionHeader {...page}>30 days after past due</SectionHeader>
          <DropdownRow
            {...page}
            label="Enabled"
            marginTop
            keyName={LocationVarKey.SequencePastDueDay30Enabled}
            options={[
              { label: "Enabled", value: SequenceEnabledStatus.ENABLED },
              { label: "Disabled", value: SequenceEnabledStatus.DISABLED },
              { label: "Simulated", value: SequenceEnabledStatus.SIMULATED }
            ]}
          />
          <Section {...page} hideIf={IS_EQUAL(LocationVarKey.SequencePastDueDay30Enabled, SequenceEnabledStatus.DISABLED)}>
            <DropdownRow
              {...page}
              label="Time"
              marginTop
              keyName={LocationVarKey.SequencePastDueDay30Time}
              options={OptionsHelper.hoursOptionsLocalized()}
            />
            <h6>
              <b>Channel</b>
            </h6>
            <br></br>
            <SwitchRow
              {...page}
              hideIf={IS_NOT_EQUAL(LocationVarKey.swivlHasVoice, "1")}
              keyName={LocationVarKey.FMSplusp30PastDueVoiceEnabled}
              label="Voice"
            />
            <SwitchRow {...page} keyName={LocationVarKey.FMSplusp30PastDueSMSEnabled} label="SMS" />
            <InputRow
              {...page}
              hideIf={IF_ANY([
                IS_NOT_EQUAL(LocationVarKey.FMSplusp30PastDueSMSEnabled, "1"),
                IS_NOT_EQUAL(LocationVarKey.FMSplusPastDueShortlinksEnabled, "1")
              ])}
              keyName={LocationVarKey.FMSplusp30PastDueSMSShortlink}
              label="SMS Link to Shorten"
            />
            <SwitchRow {...page} keyName={LocationVarKey.FMSplusp30PastDueEmailEnabled} label="Email" />
            <InputRow
              {...page}
              hideIf={IF_ANY([
                IS_NOT_EQUAL(LocationVarKey.FMSplusp30PastDueEmailEnabled, "1"),
                IS_NOT_EQUAL(LocationVarKey.FMSplusPastDueShortlinksEnabled, "1")
              ])}
              keyName={LocationVarKey.FMSplusp30PastDueEmailShortlink}
              label="Email Link to Shorten"
            />

            <TextAreaRow
              {...page}
              hideIf={IF_ANY([IS_NOT_EQUAL(LocationVarKey.FMSplusp30PastDueVoiceEnabled, "1"), IS_NOT_EQUAL(LocationVarKey.swivlHasVoice, "1")])}
              marginTop
              label=" Voice Message"
              keyName={LocationVarKey.FMSplusp30PastDueVoiceMessage}
            />

            <Section {...page} hideIf={IS_NOT_EQUAL(LocationVarKey.FMSplusp30PastDueSMSEnabled, "1")}>
              <TextAreaRow {...page} marginTop label=" SMS Message 1" keyName={LocationVarKey.FMSplusp30PastDue1} />
              <TextAreaRow
                {...page}
                hideIf={IF_ANY([
                  IS_EQUAL(LocationVarKey.FMSplusPastDueShortlinksEnabled, "1"),
                  IS_EQUAL(LocationVarKey.HasPastDueSpotPaymentPages, "1")
                ])}
                marginTop
                label=" SMS Message 2 (Optional)"
                keyName={LocationVarKey.FMSplusp30PastDue2}
                enableSwitchVar={LocationVarKey.FMSplusp30PastDue2Enabled}
              />
              <TextAreaRow
                {...page}
                hideIf={IF_ALL([
                  IS_NOT_EQUAL(LocationVarKey.FMSplusPastDueShortlinksEnabled, "1"),
                  IS_NOT_EQUAL(LocationVarKey.HasPastDueSpotPaymentPages, "1")
                ])}
                marginTop
                label=" SMS Message 2 (Optional)"
                keyName={LocationVarKey.FMSplusp30PastDue2Shortlink}
                enableSwitchVar={LocationVarKey.FMSplusp30PastDue2Enabled}
              />
              <TextAreaRow
                {...page}
                marginTop
                label=" SMS Message 3 (Optional)"
                keyName={LocationVarKey.FMSplusp30PastDue3}
                enableSwitchVar={LocationVarKey.FMSplusp30PastDue3Enabled}
              />
            </Section>
          </Section>
        </>
      )}

      {sequenceArray && SequenceHelper.isAnySequenceSubType(SequenceSubType.PAST_DUE_DAY_45, sequenceArray) && (
        <>
          <SectionHeader {...page}>45 days after past due</SectionHeader>
          <DropdownRow
            {...page}
            label="Enabled"
            marginTop
            keyName={LocationVarKey.SequencePastDueDay45Enabled}
            options={[
              { label: "Enabled", value: SequenceEnabledStatus.ENABLED },
              { label: "Disabled", value: SequenceEnabledStatus.DISABLED },
              { label: "Simulated", value: SequenceEnabledStatus.SIMULATED }
            ]}
          />
          <Section {...page} hideIf={IS_EQUAL(LocationVarKey.SequencePastDueDay45Enabled, SequenceEnabledStatus.DISABLED)}>
            <DropdownRow
              {...page}
              label="Time"
              marginTop
              keyName={LocationVarKey.SequencePastDueDay45Time}
              options={OptionsHelper.hoursOptionsLocalized()}
            />
            <h6>
              <b>Channel</b>
            </h6>
            <br></br>
            <SwitchRow
              {...page}
              hideIf={IS_NOT_EQUAL(LocationVarKey.swivlHasVoice, "1")}
              keyName={LocationVarKey.FMSplusp45PastDueVoiceEnabled}
              label="Voice"
            />
            <SwitchRow {...page} keyName={LocationVarKey.FMSplusp45PastDueSMSEnabled} label="SMS" />
            <InputRow
              {...page}
              hideIf={IF_ANY([
                IS_NOT_EQUAL(LocationVarKey.FMSplusp45PastDueSMSEnabled, "1"),
                IS_NOT_EQUAL(LocationVarKey.FMSplusPastDueShortlinksEnabled, "1")
              ])}
              keyName={LocationVarKey.FMSplusp45PastDueSMSShortlink}
              label="SMS Link to Shorten"
            />
            <SwitchRow {...page} keyName={LocationVarKey.FMSplusp45PastDueEmailEnabled} label="Email" />
            <InputRow
              {...page}
              hideIf={IF_ANY([
                IS_NOT_EQUAL(LocationVarKey.FMSplusp45PastDueEmailEnabled, "1"),
                IS_NOT_EQUAL(LocationVarKey.FMSplusPastDueShortlinksEnabled, "1")
              ])}
              keyName={LocationVarKey.FMSplusp45PastDueEmailShortlink}
              label="Email Link to Shorten"
            />

            <TextAreaRow
              {...page}
              hideIf={IF_ANY([IS_NOT_EQUAL(LocationVarKey.FMSplusp45PastDueVoiceEnabled, "1"), IS_NOT_EQUAL(LocationVarKey.swivlHasVoice, "1")])}
              marginTop
              label=" Voice Message"
              keyName={LocationVarKey.FMSplusp45PastDueVoiceMessage}
            />

            <Section {...page} hideIf={IS_NOT_EQUAL(LocationVarKey.FMSplusp45PastDueSMSEnabled, "1")}>
              <TextAreaRow {...page} marginTop label=" SMS Message 1" keyName={LocationVarKey.FMSplusp45PastDue1} />
              <TextAreaRow
                {...page}
                hideIf={IF_ANY([
                  IS_EQUAL(LocationVarKey.FMSplusPastDueShortlinksEnabled, "1"),
                  IS_EQUAL(LocationVarKey.HasPastDueSpotPaymentPages, "1")
                ])}
                marginTop
                label=" SMS Message 2 (Optional)"
                keyName={LocationVarKey.FMSplusp45PastDue2}
                enableSwitchVar={LocationVarKey.FMSplusp45PastDue2Enabled}
              />
              <TextAreaRow
                {...page}
                hideIf={IF_ALL([
                  IS_NOT_EQUAL(LocationVarKey.FMSplusPastDueShortlinksEnabled, "1"),
                  IS_NOT_EQUAL(LocationVarKey.HasPastDueSpotPaymentPages, "1")
                ])}
                marginTop
                label=" SMS Message 2 (Optional)"
                keyName={LocationVarKey.FMSplusp45PastDue2Shortlink}
                enableSwitchVar={LocationVarKey.FMSplusp45PastDue2Enabled}
              />
              <TextAreaRow
                {...page}
                marginTop
                label=" SMS Message 3 (Optional)"
                keyName={LocationVarKey.FMSplusp45PastDue3}
                enableSwitchVar={LocationVarKey.FMSplusp45PastDue3Enabled}
              />
            </Section>
          </Section>
        </>
      )}
      {sequenceArray && SequenceHelper.isAnySequenceSubType(SequenceSubType.CUSTOM, sequenceArray) && (
        <>
          <SectionHeader {...page}>Recurring reminders</SectionHeader>
          <DropdownRow
            {...page}
            label="Enabled"
            marginTop
            keyName={LocationVarKey.SequencePastDueRecurringEnabled}
            options={[
              { label: "Enabled", value: SequenceEnabledStatus.ENABLED },
              { label: "Disabled", value: SequenceEnabledStatus.DISABLED },
              { label: "Simulated", value: SequenceEnabledStatus.SIMULATED }
            ]}
          />
          <Section {...page} hideIf={IS_EQUAL(LocationVarKey.SequencePastDueRecurringEnabled, SequenceEnabledStatus.DISABLED)}>
            <DropdownRow
              {...page}
              label="Time"
              marginTop
              keyName={LocationVarKey.SequencePastDueRecurringTime}
              options={OptionsHelper.hoursOptionsLocalized()}
            />
            <h6>
              <b>Channel</b>
            </h6>
            <br></br>
            <SwitchRow
              {...page}
              hideIf={IS_NOT_EQUAL(LocationVarKey.swivlHasVoice, "1")}
              keyName={LocationVarKey.FMSplusRecurringPastDueVoiceEnabled}
              label="Voice"
            />
            <SwitchRow {...page} keyName={LocationVarKey.FMSplusRecurringPastDueSMSEnabled} label="SMS" />
            <InputRow
              {...page}
              hideIf={IF_ANY([
                IS_NOT_EQUAL(LocationVarKey.FMSplusRecurringPastDueSMSEnabled, "1"),
                IS_NOT_EQUAL(LocationVarKey.FMSplusPastDueShortlinksEnabled, "1")
              ])}
              keyName={LocationVarKey.FMSplusRecurringPastDueSMSShortlink}
              label="SMS Link to Shorten"
            />
            <SwitchRow {...page} keyName={LocationVarKey.FMSplusRecurringPastDueEmailEnabled} label="Email" />
            <InputRow
              {...page}
              hideIf={IF_ANY([
                IS_NOT_EQUAL(LocationVarKey.FMSplusRecurringPastDueEmailEnabled, "1"),
                IS_NOT_EQUAL(LocationVarKey.FMSplusPastDueShortlinksEnabled, "1")
              ])}
              keyName={LocationVarKey.FMSplusRecurringPastDueEmailShortlink}
              label="Email Link to Shorten"
            />

            <TextAreaRow
              {...page}
              hideIf={IF_ANY([
                IS_NOT_EQUAL(LocationVarKey.FMSplusRecurringPastDueVoiceEnabled, "1"),
                IS_NOT_EQUAL(LocationVarKey.swivlHasVoice, "1")
              ])}
              marginTop
              label=" Voice Message"
              keyName={LocationVarKey.FMSplusRecurringPastDueVoiceMessage}
            />

            <Section {...page} hideIf={IS_NOT_EQUAL(LocationVarKey.FMSplusRecurringPastDueSMSEnabled, "1")}>
              <TextAreaRow {...page} marginTop label=" SMS Message 1" keyName={LocationVarKey.FMSplusRecurringPastDue1} />
              <TextAreaRow
                {...page}
                hideIf={IF_ANY([
                  IS_EQUAL(LocationVarKey.FMSplusPastDueShortlinksEnabled, "1"),
                  IS_EQUAL(LocationVarKey.HasPastDueSpotPaymentPages, "1")
                ])}
                marginTop
                label=" SMS Message 2 (Optional)"
                keyName={LocationVarKey.FMSplusRecurringPastDue2}
                enableSwitchVar={LocationVarKey.FMSplusRecurringPastDue2Enabled}
              />
              <TextAreaRow
                {...page}
                hideIf={IF_ALL([
                  IS_NOT_EQUAL(LocationVarKey.FMSplusPastDueShortlinksEnabled, "1"),
                  IS_NOT_EQUAL(LocationVarKey.HasPastDueSpotPaymentPages, "1")
                ])}
                marginTop
                label=" SMS Message 2 (Optional)"
                keyName={LocationVarKey.FMSplusRecurringPastDue2Shortlink}
                enableSwitchVar={LocationVarKey.FMSplusRecurringPastDue2Enabled}
              />
            </Section>
          </Section>
        </>
      )}
    </>
  );
}
